import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { types as iconTypes } from "../../../config/alerts";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: false,
};

class StatusBar extends Marionette.ItemView {
  constructor(options = {}) {
    Object.assign(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // 10 second timeout
    this.statusTimeout = 10 * 1000;
    this.delay = null;

    this.icons = {
      success: this._createIconMarkup(iconTypes.success),
      info: this._createIconMarkup(iconTypes.info),
      warning: this._createIconMarkup(iconTypes.warning),
      failure: this._createIconMarkup(iconTypes.danger),
    };

    // setup listeners
    this.listenTo(channel, "status-bar:clear", this._onClear);
    this.listenTo(channel, "status-bar:update", this._onUpdate);

    channel.trigger("status-bar:ready");
  }

  _onClear() {
    this._updateHtml(null);
  }

  _onUpdate(message, type = "info") {
    // reset timeout
    this._setTimeout();

    const markup = `${this.icons[type]}&nbsp;${message}`;
    this._updateHtml(markup);
  }

  _updateHtml(html) {
    this.$el.html(html);
  }

  _setTimeout() {
    if (this.delay !== null && _.isNumber(this.delay)) {
      // clear previous timeout
      window.clearTimeout(this.delay);
    }

    // set delay
    this.delay = _.delay(this._onTimeout.bind(this), this.statusTimeout);
  }

  _onTimeout() {
    this._onClear();
  }

  _createIconMarkup(icon) {
    return `<i class="fa fa-lg fa-${icon}"></i>`;
  }
}

export { StatusBar as default };
